import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, useAttrs } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'SfxBtn',
  props: {
  class: {
    type: String,
    default: undefined,
  },
},
  setup(__props) {

const props = __props



//endregion

//region Variables

const attrs = useAttrs()

const isDisabled = computed(() => attrs.disable)

const filteredAttrs = computed(() => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { disable, ...restAttrs } = attrs
  if (restAttrs.onClick && typeof restAttrs.onClick === "function") {
    restAttrs.onClick = handleClickEvent(restAttrs.onClick)
  }
  return restAttrs
})

//endregion

//region Functions

function handleClickEvent(clickFn: unknown) {
  if (isDisabled.value) return
  return clickFn
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
    unelevated: "",
    "no-caps": "",
    color: "primary",
    class: `sfx-btn${props.class ? ` ${props.class}` : ''} ${isDisabled.value ? ' disabled' : ''}`
  }, filteredAttrs.value), _createSlots({ _: 2 }, [
    (_ctx.$slots.default)
      ? {
          name: "default",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.loading)
      ? {
          name: "loading",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "loading")
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["class"]))
}
}

})